module.exports = __webpack_public_path__ + "assets/img/fdfd.5814e723.png";